"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ParallaxContext = _react.default.createContext(null);

var _default = ParallaxContext;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-scroll-parallax/cjs/helpers/ParallaxContext.js
// module id = 24
// module chunks = 0